export default () => {
	const PluginMyOffer = Component(function ($context) {
		return $context.select('.my-offer');
	}, function ($myoffer, self) {
		$.extend(self, {
			initEventListeners: function () {
				$myoffer.on('click', '.my-offer__open-form', function () {
					const $btn = $(this);
					const $content = $($btn.data('form'));
					const format = $btn.data('format');

					if (format !== undefined) {
						console.log($content.find(`.checkbox__input[value="${format}"]`));
						$content.find(`.checkbox__input[value="${format}"]`).prop('checked', true);
					}

					self.openModal($content);
				});
				$myoffer.on('click', '.my-offer__get-document', function () {
					self.getOfferDocument($(this));
				});

				$myoffer.on('click', '.my-offer__btn-toggle', function () {
					$(this).toggleClass('active');
					$myoffer.find('.my-offer__toggle').slideToggle(300);
				})
			},
			openModal: function ($modalContent) {
				ModalUtil.openContent($modalContent, function () {
					const $formBlock = $modalContent.find('.my-offer-form');
					self.initForm($formBlock);
				}, null, {
					enableEscapeKey: false
				});
			},
			initForm: function ($formBlock) {
				$formBlock.on('click', '.my-offer-form__button', function () {
					self.sendForm($formBlock);
				});

				$formBlock.on('input', 'input', function () {
					const $input = $(this);
					const $formgroup = $input.closest('.formgroup');
					$formgroup.toggleClass('formgroup--error', $input.val() === '');
				});
			},
			sendForm: function ($form) {
				const $parent = $form.parent();
				const $groupPolicy = $parent.find('.my-offer-modal__formgroup-policy');
				const $policy = $groupPolicy.find('.my-offer-modal__policy');

				if ($policy.length && !$policy.prop('checked')) {
					$groupPolicy.addClass('formgroup--error');
					return;
				} else if ($policy.length) {
					$groupPolicy.removeClass('.formgroup--error')
				}

				const $input = $form.find('.my-offer-form__input');
				const inputVal = $input.val();

				if (!inputVal.length) {
					$form.find('.formgroup').addClass('formgroup--error');
					return false;
				}

				const isRestore = $form.hasClass('my-offer-form--restore');
				const url = $form.data('action');
				const method = $form.data('method');
				const $groupFormat = $parent.find('.my-offer-modal__file-format');
				const $format = $groupFormat.find('.checkbox__input:checked');
				const $sku = $parent.find('.my-offer-modal__sku');

				const data = [$input, $format, $sku].reduce((acc, $elm) => {
					if ($elm.length && !!$elm.val()) {
						acc[[$elm.prop('name')]] = $elm.val();
					}
					return acc;
				}, {});

				if (Cookies.get('shop_cart') === undefined && url === '/restore-cart-items-from-offer/') {
					const date = new Date();
					Cookies.set('shop_cart', Date.parse(date));
				}

				$.ajax({
					type: method,
					url: url,
					data: data
				}).then((response) => {
					let errors = self.getErrors(response);

					if (errors !== null) {
						self.setErrors($form.parent(), errors);
						return;
					}

					const $successBlock = $('<div class="my-offer-form__success"></div>');
					const $successTop = $('<div class="my-offer-form__success-top"></div>');
					const $successBottom = $('<div class="my-offer-form__success-bottom"></div>');

					$parent.find('.my-offer-modal__title').remove();
					[$groupFormat, $groupPolicy].forEach($elm => $elm.hide());

					if (isRestore) {
						self.refresh();
						$successTop.text('Товары из коммерческого предложения добавлены в корзину');
						$successBottom.html('<button class="my-offer-form__close btn">Продолжить</button>')
					} else {
						$successTop.text('Коммерческое предложение отправлено на почту:');
						$successBottom.html('<div class="my-offer-form__email">' + inputVal + '</div>');
					}

					$successBlock.append($successTop, $successBottom);
					$form.html($successBlock);

					window.setTimeout(function () {
						ModalUtil.close();
					}, 3000);
				}).fail(jqXHR => {
					let resp = jqXHR.responseJSON;
					let errors = self.getErrors(resp);

					if (errors === null) {
						errors = ['Неизвестная ошибка'];
					}

					self.setErrors($form.parent(), errors);
				});
			},
			getOfferDocument: function ($span) {
				const method = 'POST';
				const saveUrl = '/save-offer/';
				const skuId = $span.data('sku_id')
				const saveData = {'email': $span.data('email'), ...(skuId !== undefined && {sku_id: skuId})};
				const documentFormat = $span.data('format') || 'word';

				$.ajax({
					type: method,
					url: saveUrl,
					data: saveData
				}).then((response) => {
					let errors = self.getErrors(response);

					if (errors !== null) {
						self.setErrors($span, errors);
						return;
					}

					const downloadUrl = `/show-${documentFormat}-offer/${response.data.offer_id}/`;

					const $link = $('<a>', {href: downloadUrl, download: true}).hide();
					$link.appendTo(document.body)[0].click();
					$link.remove();

				}).fail(jqXHR => {
					let resp = jqXHR.responseJSON;
					let errors = self.getErrors(resp);

					if (errors === null) {
						errors = ['Неизвестная ошибка'];
					}

					self.setErrors($span, errors);
				});
			},
			getErrors(resp) {
				if (!resp) {
					return ['Неизвестная ошибка'];
				}

				if (resp.status !== 'fail' && resp.status !== 'ok') {
					return ['Неизвестная ошибка'];
				}

				if (resp.status === 'fail') {
					return resp.errors;
				}

				return null;
			},
			setErrors: function (block, errors) {
				$('.my-offer__error').remove();
				const $errorBlock = $('<div class="my-offer__error"></div>');

				for (let i = 0; i < errors.length; i++) {
					$errorBlock.append(errors[i]);
				}

				block.append($errorBlock);
			},
			refresh: function () {
				$.ajax({
					url: ''
				}).then((response) => {
					const $response = $(response);
					const $shopPage = $myoffer.closest('.shop-page');
					const $new_page = $response.find('.shop-page').add($response.filter('.shop-page'));
					$shopPage.html($new_page.html());
					Update($shopPage);
				});
			}
		});

		self.initEventListeners();
	});

	window.ObserverUtil.observeComponent('my-offer', PluginMyOffer);
	return PluginMyOffer
}
